import { PaletteColor, RGBColor } from "../defines/colors"
import { ItemType } from "../defines/enums"
import { RGB } from "../defines/types"

function getColorForOptic(optic?: ItemType): PaletteColor {
  let color = PaletteColor.NONE

  if (optic !== undefined) {
    switch (optic) {
      case ItemType.OPTIC_RED:
        color = PaletteColor.RED
        break
      case ItemType.OPTIC_BLUE:
        color = PaletteColor.BLUE
        break
      case ItemType.OPTIC_GREEN:
        color = PaletteColor.GREEN
        break
      case ItemType.OPTIC_MAGENTA:
        color = PaletteColor.MAGENTA
        break
      case ItemType.OPTIC_CYAN:
        color = PaletteColor.CYAN
        break
      case ItemType.OPTIC_YELLOW:
        color = PaletteColor.YELLOW
        break
    }
  }

  return color
}

function getPaletteColor(color: string): PaletteColor {
  switch (color.toUpperCase()) {
    case "RED":
      return PaletteColor.RED
    case "GREEN":
      return PaletteColor.GREEN
    case "BLUE":
      return PaletteColor.BLUE
    case "YELLOW":
      return PaletteColor.YELLOW
    case "MAGENTA":
      return PaletteColor.MAGENTA
    case "CYAN":
      return PaletteColor.CYAN
  }

  return PaletteColor.NONE
}

function getOutputStringForColor(color: PaletteColor): string {
  let output: string = "unknown"

  switch (color) {
    case PaletteColor.RED:
      output = "red"
      break
    case PaletteColor.BLUE:
      output = "blue"
      break
    case PaletteColor.GREEN:
      output = "green"
      break
    case PaletteColor.YELLOW:
      output = "yellow"
      break
    case PaletteColor.MAGENTA:
      output = "magenta"
      break
    case PaletteColor.CYAN:
      output = "cyan"
      break
  }

  return output
}

function getHexForPaletteColor(color: PaletteColor): string {
  let hex: string = ""

  switch (color) {
    case PaletteColor.RED:
      hex = "#f00"
      break
    case PaletteColor.GREEN:
      hex = "#0f0"
      break
    case PaletteColor.BLUE:
      hex = "#00f"
      break
    case PaletteColor.YELLOW:
      hex = "#ff0"
      break
    case PaletteColor.MAGENTA:
      hex = "#f0f"
      break
    case PaletteColor.CYAN:
      hex = "#0ff"
      break
  }

  return hex
}

function rgbToPaletteColor(
  red: number,
  green: number,
  blue: number
): PaletteColor | undefined {
  if (red == 255 && green == 0 && blue == 0) {
    return PaletteColor.RED
  } else if (red == 0 && green == 255 && blue == 0) {
    return PaletteColor.GREEN
  } else if (red == 0 && green == 0 && blue == 255) {
    return PaletteColor.BLUE
  } else if (red == 255 && green == 255 && blue == 0) {
    return PaletteColor.YELLOW
  } else if (red == 255 && green == 0 && blue == 255) {
    return PaletteColor.MAGENTA
  } else if (red == 0 && green == 255 && blue == 255) {
    return PaletteColor.CYAN
  }

  return undefined
}

function paletteColorToRGB(color: PaletteColor): RGB | undefined {
  switch (color) {
    case PaletteColor.RED:
      return RGBColor.RED
    case PaletteColor.GREEN:
      return RGBColor.GREEN
    case PaletteColor.BLUE:
      return RGBColor.BLUE
    case PaletteColor.YELLOW:
      return RGBColor.YELLOW
    case PaletteColor.MAGENTA:
      return RGBColor.MAGENTA
    case PaletteColor.CYAN:
      return RGBColor.CYAN
  }

  return undefined
}

function toDisplayString(rgb: RGB): string {
  const alpha = rgb.a !== undefined ? rgb.a : 1
  return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha})`
}

export {
  getColorForOptic,
  getHexForPaletteColor,
  getOutputStringForColor,
  getPaletteColor,
  paletteColorToRGB,
  rgbToPaletteColor,
  toDisplayString,
}
